import { Button, PadlockSquare } from '@taskall/react';
import { Card, EmptyState } from '@taskall/ui';
import { useNavigate } from 'react-router-dom';

export function ForbiddenPage() {
  const navigate = useNavigate();
  return (
    <Card>
      <EmptyState
        icon={PadlockSquare}
        title="Acesso restrito"
        description="Seu perfil não possui permissão para acessar esta área."
        action={<Button onClick={() => navigate('/dashboard')}>Voltar ao painel</Button>}
      />
    </Card>
  );
}
